<template>
  <div
    v-if="id != ''"
    class="card"
    :style="{ 'background-image': `url('http://${bgImg}')` }"
    @click="toEdit"
  >
    <div class="name" style="color: var(--white)">
      <span v-if="!renameType">{{ name }}</span>
      <el-input
        v-if="renameType"
        style="width: 180px; position: relative; top: 8px; left: 10px"
        @keyup.enter="renameFn"
        placeholder="请输入名称，回车键保存"
        size="mini"
        v-model="rename"
      >
      </el-input>
      <el-button
        style="position: absolute; top: 6px; left: 200px"
        v-if="renameType"
        @click.stop="
          renameType = false;
          rename = '';
        "
        type="text"
        size="small"
        >取消</el-button
      >
      <!-- <el-button class="delete"
                 @click.stop="deleteTemplate"
                 type="text">删除</el-button> -->
      <el-popover placement="bottom" :width="80" trigger="hover">
        <template #reference>
          <div class="delete">...</div>
        </template>
        <div class="other-options">
          <div class="option" @click.stop="renameType = true">重命名</div>
          <div class="option" @click.stop="deleteTemplate">删除</div>
        </div>
      </el-popover>
    </div>
  </div>
  <div v-else class="card" @click="toCreated">
    <i class="add iconfont icon-icon_add" />
    <div class="blank-template" style="color: var(--main-text)">
      <span>空白模板</span>
    </div>
  </div>
</template>

<script>
import { renameTemplate } from '../../../API/template'
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    bgImg: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      renameType: false,
      rename: ''
    }
  },
  computed: {
  },
  methods: {
    toCreated () {
      console.log('99999999999999999')
      this.$router.push({
        path: '/create-project/created/null'
      })
    },
    deleteTemplate () {
      this.$confirm('删除后无法复原', '确认删除当前方案', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$emit('deleteTemplate', this.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async renameFn () {
      const res = await renameTemplate({ templateUid: this.id, name: this.rename })
      console.log('res', res)
      this.$message({
        type: 'success',
        message: '修改成功'
      })
      this.$emit('reloadTemplate', '', () => {
        this.renameType = false
        this.rename = ''
      })
    },
    toEdit () {
      if (this.renameType) {
        return
      }
      this.$router.push({
        path: `/create-project/edit/${this.id ? this.id : null}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.other-options {
  background: #fff;
  margin: -12px;
  .option {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 13px;
    font-size: 11px;
    cursor: pointer;
    &:hover {
      background: #dde4f0;
    }
  }
}
.card {
  cursor: pointer;
  width: 291px;
  height: 148px;

  background-image: url("http://imgw.pospal.cn/we/advertisingPlatform/templateCardBg.png");
  border-radius: 4px;
  position: relative;
  margin-right: 12px;
  object-fit: fill;
  margin-bottom: 13px;
  background-size: 100% 100%;
  .add {
    position: absolute;
    left: 28px;
    top: 34px;
    font-size: 36px;
    color: var(--main-text);
  }
  .blank-template {
    position: absolute;
    left: 28px;
    bottom: 25px;
    font-size: 16px;
  }
  .name {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 44px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 0px 0px 4px 4px;
    .delete {
      font-size: 28px;
      position: absolute;
      left: 245px;
      bottom: 7px;
      display: flex;
      line-height: 12px;
      height: 32px;
      width: 32px;
      justify-content: center;
      align-content: center;
      border-radius: 2px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    span {
      font-size: 16px;
      position: absolute;
      left: 26px;
      bottom: 14px;
    }
  }
}
</style>
